import { SBack, SMessage } from 'shj-components'
import { Button, message, Steps, Spin } from 'antd'
import { useSetState, useUpdateEffect } from 'ahooks'
import { CheckCircleOutlined } from '@ant-design/icons'
import {
  getSpaceSpecificationArg,
  getSpaceTagsByPackModelId,
  submitConfigAndNode,
  getPackTreeNode,
  getPackModelSpaceConfig
} from '@/services/product'
import SpaceSpecsStep1 from './steps/step1';
import SpaceSpecsStep2 from './steps/step2';
import styles from './index.module.less'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

const SetSpaceSpecs = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const listRef1 = useRef()
  const listRef2 = useRef()

  const [btnLoading, setBtnLoading] = useState(false);
  const [current, setCurrent] = useState(0);
  const [specsArgList, setSpecsArgList] = useState([]);
  const [specsArgMap, setSpecsArgMap] = useState({});
  const [spaceList, setSpaceList] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);

  useEffect(() => {
    getInfo()
  }, [])

  useEffect(() => {
    getTableData();
  }, [id])

  const getInfo = async () => {
    try {
      const argList: any = [];
      const argMap: any = {};
      const specsArgRes: any = await getSpaceSpecificationArg({
        enabled: true,
      });
      if (specsArgRes?.length) {
        specsArgRes.forEach(specs => {
          argList.push({
            argCode: specs.argCode,
            argName: specs.argName,
            id: specs.id,
          })
          argMap[specs.id] = specs.values;
        })
        setSpecsArgList(argList);
        setSpecsArgMap(argMap);
      }
      const spaceRes: any = await getSpaceTagsByPackModelId(id);
      if (spaceRes?.length) {
        setSpaceList(spaceRes);
      }
    } catch (err) {
      console.log(err)
    }
  }

  const getTableData = async () => {
    let step1Ids: any = [];
    const table1Res: any = await getPackModelSpaceConfig({
      packModelId: id,
      queryParamValue: true,
    })
    if (table1Res?.length) {
      setTableData1(table1Res);
      listRef1.current?.updateDataSource(table1Res, table1Res?.length);
    }
    step1Ids = table1Res.map(item => item.spaceCode);
    const table2Res: any = await getPackTreeNode({
      sourceType: 'PACK_MODEL',
      sourceId: id,
      querySpaceSpec: true,
      hasSpaceTag: true,
      expirationTimeIsNull: true,
      busTypes: ['PRD_PRODUCT','PRD_GEN_ITEM']
    })
    if (table2Res?.length) {
      const list = table2Res.filter(((item: any) => step1Ids.includes(item.spaceTag)))
      setTableData2(list);
      listRef2.current?.updateDataSource(list, list?.length);
    }
  }

  const stepList: any[] = [
    {
      subTitle: '空间规格设置',
      components: (
        <SpaceSpecsStep1
          listRef={listRef1}
          specsArgList={specsArgList}
          specsArgMap={specsArgMap}
          spaceList={spaceList}
          tableData={tableData1}
          setTableData={setTableData1}
        />
      ),
    },
    {
      subTitle: '打包设置',
      components: (
        <SpaceSpecsStep2
          packId={id}
          listRef={listRef2}
          specsArgList={specsArgList}
          specsArgMap={specsArgMap}
          spaceList={spaceList}
          preTableData={tableData1}
          tableData={tableData2}
          setTableData={setTableData2}
        />
      ),
    },
  ]

  const onNext = () => {
    setCurrent(current + 1 )
  }

  const onSubmit = async () => {
    setBtnLoading(true);
    const res = await submitConfigAndNode({
      packModelId: id,
      configs: tableData1,
      nodes: tableData2,
    })
    if (res) {
      navigate('/config/baseProduct/packageTemplate');
    }
    setBtnLoading(false);
  }

  const goBack = () => {
    SMessage.confirm({
      title: '确认继续返回',
      content: '返回将不会保存已添加信息',
      onOk: () => {
        navigate('/config/baseProduct/packageTemplate', { state: { saveCache: true }})
      },
    })
  }

  return (
    <SBack
      title={(id ? '编辑' : '新增') + '空间规格'}
      level={2}
      goPath={goBack}
      extra={[
        <Button loading={btnLoading} onClick={goBack}>
          取消
        </Button>,
        current > 0 && (
          <Button
            style={{ marginLeft: 10 }}
            onClick={() => setCurrent(current - 1 )}
          >
            上一步
          </Button>
        ),
        current <= 0 ? (
          <Button type="primary" style={{ marginLeft: 10 }} onClick={onNext}>
            下一步
          </Button>
        ) : (
          <Button type="primary" style={{ marginLeft: 10 }} loading={btnLoading} onClick={onSubmit}>
            保存
          </Button>
        ),
      ]}
    >
      <Spin spinning={btnLoading}>
        <div className={styles.container}>
          <div className={styles.step_wrap} style={{ display: current !== 2 ? 'block' : 'none' }}>
            <div className={styles.step_box} style={{ width: 800 }}>
              <Steps
                style={{ width: '80%' }}
                current={current}
                // labelPlacement={'vertical'}
                items={stepList.map(item => ({ key: item.subTitle, title: item.subTitle }))}
              />
            </div>
          </div>
          <div>
            {stepList.map((item, i) => (
              <div key={i} style={{ display: current === i ? 'block' : 'none' }}>
                {item.components}
              </div>
            ))}
          </div>
        </div>
      </Spin>
    </SBack>
  )
}
export default SetSpaceSpecs
